<template>
  <a-checkbox
    v-model:checked="raceLock"
    :disabled="langCode !== langDic[0].value"
  >
    锁定（不进行赛马排序）
  </a-checkbox>
</template>

<script>
import { computed, reactive, toRefs, inject } from 'vue'

export default {
  props: {
    praceLock: {
      type: Number,
      default: () => 0
    }
  },
  setup(props, { emit }) {
    const state = reactive({
      count: 0
    })
    const initState = inject('initState')
    const raceLock = computed({
      get() {
        return props.praceLock - 0 === 1
      },
      set(v) {
        emit('update:praceLock', v ? 1 : 0)
        return v
      }
    })

    return {
      ...toRefs(initState),
      ...toRefs(state),
      raceLock
    }
  }
}
</script>
